<template>
    <div class="bg-Primary w-screen h-screen flex flex-col gap-2 justify-center items-center">
        <h1 class="text-white text-7xl font-bold">404</h1>
        <h2 class="text-white text-4xl font-medium">Page Not Found</h2>
    </div>
</template>

<script setup>

</script>